module.exports = __webpack_public_path__ + "static/media/Success.4bdc564d.svg";